import React, { FC } from 'react';
import { PopoverFactoryRenderer } from '../../components/popovers/PopoverFactoryRenderer';
import { Enterprise } from '../entity.types';
import { EnterprisePopover } from '../../enterprise/components/popover/EnterprisePopover';
import {
  EntityListItem,
  EntityListIcon,
  EntityListGroup,
} from './components/EntityListComponents';
import { EntityListSubtitle } from './components/subtitle/EntityListSubtitle';
import { EntityListLinkTitle } from './components/title/EntitlyListLinkTitle';

type Props = {
  enterprises: Array<Enterprise>;
  source: string;
  wording: string;
  handleClickDecision: Function;
  fromModal?: boolean;
};

export const EnterpriseList: FC<Props> = ({
  source,
  enterprises,
  wording,
  handleClickDecision,
  fromModal = false,
}) => {
  const displayPopover = (element: HTMLElement) => {
    const siren = element.getAttribute('data-enterprise');
    if (siren) {
      return <EnterprisePopover source={`${source}_popover`} siren={siren} />;
    }
  };

  return (
    <PopoverFactoryRenderer
      renderTemplate={displayPopover}
      isPopoverInsideModal={fromModal}
    >
      {enterprises.map(enterprise => (
        <EntityListItem key={enterprise.siren}>
          <EntityListIcon
            src="/img/icons/entities/enterprise.svg"
            alt="enteprise-icon"
          />
          <EntityListGroup>
            <EntityListLinkTitle
              source={source}
              entityId={enterprise.siren}
              entityUrl={enterprise.url}
              entityName={enterprise.name}
            />
            <br />
            <EntityListSubtitle
              wording={wording}
              handleClickDecision={handleClickDecision}
              entity={enterprise}
            />
          </EntityListGroup>
        </EntityListItem>
      ))}
    </PopoverFactoryRenderer>
  );
};
